<div *ngIf="showLoading" class="reward-detail-loading" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
    <div class="loading-spinner">
        <div class="large progress" alt="Loading..." aria-label="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!showLoading">
    <ng-container *ngIf="!isErrorInContent">
        <div [innerHTML]="frequentlyAskedQuestion | safeHtml"></div>
    </ng-container>
    <ng-container *ngIf="isErrorInContent">
    </ng-container>
</div>
